import React from 'react';

const SimpleBanner = ({ bgImage, headingText, height = '70vh' }) => {
  const bannerStyle = {
    backgroundImage: `url(${bgImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#fff',
    position: 'relative',
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1,
  };

  const headingStyle = {
    position: 'relative',
    zIndex: 2,
    fontSize: 'clamp(24px, 5vw, 48px)',
    fontWeight: '400',
    color: '#fff',
    fontFamily: 'Playfair Display, serif',
    textTransform: 'uppercase', // Added this line
  };

  return (
    <section style={bannerStyle}>
      <div style={overlayStyle}></div>
      <h1 style={headingStyle}>{headingText}</h1>
    </section>
  );
};

export default SimpleBanner;
